import axios from "axios";
import {API_BASE_URL} from "../constants/api";
import {ACCESS_TOKEN} from "../constants/auth";

const ApplicationService = {};

ApplicationService.createApplication = async function (applicationData) {
    const {
        crops,
        plannedWaterVolume,
        startDate,
        endDate,
        channelNumber,
        channelName,
        specificWaterConsumptionRate,
        irrigatedArea,
        location,
        cadastralNumber,
        waterMeteringMethod,
        monthlyWaterVolumes
    } = applicationData;

    let data = new FormData();
    data.append("crops", crops);
    data.append("plannedWaterVolume", plannedWaterVolume);
    data.append("startDate", startDate);
    data.append("endDate", endDate);
    if (channelNumber) data.append("channelNumber", channelNumber);
    if (channelName) data.append("channelName", channelName);
    if (specificWaterConsumptionRate) data.append("specificWaterConsumptionRate", specificWaterConsumptionRate);
    if (irrigatedArea) data.append("irrigatedArea", irrigatedArea);
    if (location) data.append("location", location);
    if (cadastralNumber) data.append("cadastralNumber", cadastralNumber);
    if (waterMeteringMethod) data.append("waterMeteringMethod", waterMeteringMethod);
    if (monthlyWaterVolumes) data.append("monthlyWaterVolumes", monthlyWaterVolumes);

    return axios({
        method: "post",
        url: API_BASE_URL + "/api/application/create",
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

ApplicationService.getMyApplications = async function () {
    return axios({
        method: "get",
        url: API_BASE_URL + "/api/application/my",
        headers: {
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

ApplicationService.getApplicationById = async function (id) {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/application/${id}`,
        headers: {
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

ApplicationService.getContractDraft = async function (id) {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/application/${id}/contract-draft`,
        responseType: 'blob',
        headers: {
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

ApplicationService.saveApplicationSignature = async function (applicationId, fullName, docDetails, signDate, signatureBase64) {
    let data = new FormData();
    data.append("applicationId", applicationId);
    data.append("fullName", fullName);
    data.append("docDetails", docDetails);
    data.append("signDate", signDate);
    data.append("signature", signatureBase64);

    return axios({
        method: "post",
        url: API_BASE_URL + "/api/application/sign",
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

export default ApplicationService;
